import { z } from 'zod/v4';

export const SearchSchema = z.object({
  search: z.string().optional(),
});

export const PaginationSchema = z.object({
  page: z.coerce.number().int().min(1).default(1).catch(1),
  pageSize: z.coerce
    .number()
    .int()
    .refine((val) => [5, 10, 25].includes(val))
    .default(10)
    .catch(10),
});

export const CommonSearchParamsSchema = z.object({
  ...SearchSchema.shape,
  ...PaginationSchema.shape,
});

// A DRF field/non-field error is `string | string[]`; normalize to one string.
const ErrorMessageSchema = z
  .union([z.string(), z.array(z.string())])
  .transform((value) => (Array.isArray(value) ? value.join(' ') : value));

// The response body is either a bare string or a map of field -> message(s).
export const ApiErrorBodySchema = z.union([
  ErrorMessageSchema,
  z.record(z.string(), ErrorMessageSchema),
]);

// RTK Query / axios base-query errors carry the response body on `data`.
export const ApiErrorSchema = z.object({ data: z.unknown() });
